// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app/styles/" + chunkId + "." + {"1387":"54abff4d8cc0c5c622d5","1558":"597816a78e044c327676"}[chunkId] + ".css";
};